import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync, StorageKey } from '@nu-art/thunderstorm-frontend/index';
import { ThisShouldNotHappenException } from '@nu-art/ts-common';
import './ResizableWrapper.scss';
export class ResizableWrapper extends ComponentSync {
    //######################### Life Cycle #########################
    wrapperRef = React.createRef();
    startX = null;
    startWidth = null;
    deriveStateFromProps(nextProps, state) {
        state.storageKey ??= new StorageKey(`resizable-wrapper__${nextProps.storageKeySuffix}`);
        state.className = nextProps.className;
        return state;
    }
    componentWillUnmount() {
        this.removeListeners();
    }
    shouldComponentUpdate() {
        return true;
    }
    //######################### Logic #########################
    getWrapper = () => {
        const wrapper = this.wrapperRef.current;
        if (!wrapper)
            throw new ThisShouldNotHappenException('Could not get wrapper from ref');
        return wrapper;
    };
    onMouseDown = (e) => {
        e.preventDefault();
        const wrapper = this.getWrapper();
        this.startX = e.clientX;
        this.startWidth = wrapper.clientWidth;
        wrapper.classList.add('resizing');
        window.addEventListener('mousemove', this.onMouseMove);
        window.addEventListener('mouseup', this.onMouseUp);
    };
    onMouseMove = (e) => {
        if (this.startX === null || this.startWidth === null)
            return;
        const delta = e.clientX - this.startX;
        const newWidth = Math.max(300, this.startWidth + delta);
        this.getWrapper().style.width = `${newWidth}px`;
    };
    onMouseUp = () => {
        this.removeListeners();
        const wrapper = this.getWrapper();
        wrapper.classList.remove('resizing');
        const finalWidth = wrapper.clientWidth;
        this.state.storageKey.set(finalWidth);
        this.startX = null;
        this.startWidth = null;
    };
    removeListeners() {
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('mouseup', this.onMouseUp);
    }
    //######################### Render #########################
    render() {
        const savedWidth = this.state.storageKey.get();
        const style = savedWidth ? { width: `${savedWidth}px` } : undefined;
        return _jsxs("div", { ref: this.wrapperRef, className: _className('resizable-wrapper', this.state.className), style: style, children: [this.props.children, _jsx("div", { className: 'resizeable-wrapper__handle', onMouseDown: this.onMouseDown })] });
    }
}
//# sourceMappingURL=ResizableWrapper.js.map